module.exports = __webpack_public_path__ + "static/Logros-9c832f1f192a25889da8481a283a1c04.png";